import { ReactComponent as LogoPrimeiraMao } from 'components/src/assets/logo/logo.svg';

const images = {
  LogoSvg: () => <LogoPrimeiraMao style={{ width: 292, height: 48 }} />,
  alt: 'Logo da PrimeiraMão',
};

export default images;
